import { Drawer, Tab, Tabs } from "components";
import { useState } from "react";
import { Sentry } from "utilz";
import { AppsForMsp } from "./AppsForMsp";
import { AppsForMspCustomers } from "./AppsForMspCustomers";

export const DownloadDrawer = ({
  open,
  onClose,
}: {
  open: boolean;
  onClose: () => void;
}) => {
  const TABS = [
    {
      label: "Apps for your customers",
      content: <AppsForMspCustomers closeDownloadDrawer={onClose} />,
    },
    {
      label: "Apps for your techs",
      content: <AppsForMsp />,
    },
  ];

  const [currentTabIndex, setCurrentTabIndex] = useState(0);

  return (
    <Sentry.ErrorBoundary fallback={<></>} onError={() => onClose()}>
      <Drawer
        open={open}
        onClose={onClose}
        title={"Download Apps"}
        additionalHeaderComponent={
          <Tabs
            value={currentTabIndex}
            onChange={(_event: React.SyntheticEvent, index: number) => {
              setCurrentTabIndex(index);
            }}
            sx={{ pl: "24px" }}
          >
            {TABS.map(({ label }) => (
              <Tab key={label} label={label} />
            ))}
          </Tabs>
        }
        drawerStyle={{
          minWidth: "458px",
        }}
        footer={<></>}
      >
        {TABS[currentTabIndex].content}
      </Drawer>
    </Sentry.ErrorBoundary>
  );
};
